import type { ReactElement } from "react"

import { ETypographyWeight, InfoBox } from "@/3514/components"
import { ENotificationType, notificationService } from "@/3514/services"
import { type IUseTranslation, useTranslation } from "@/hooks"

function NetworkErrorNotification({ notificationId }): ReactElement {
    const { t }: IUseTranslation = useTranslation()

    return (
        <InfoBox
            variant="warning"
            isDismissable
            onDismiss={(): void => notificationService.remove(notificationId)}
            title={t("common.notification.networkError.title")}
            message={t("common.notification.networkError.message")}
            action={{
                onClick: (): void => window.location.reload(),
                children: t("common.notification.networkError.action"),
                textWeight: ETypographyWeight.Medium
            }}
        />
    )
}

export default {
    [ENotificationType.NetworkError]: (notificationId: string): ReactElement => (
        <NetworkErrorNotification notificationId={notificationId} />
    )
}
